import { DaysNoticeEnums, FrequencyEnums } from "src/app/enum/article-task-enums";

export class ArticleTaskModel {
    articleTaskId: number = 0;
    branchId: number = 0;
    consecutive: number = 0;
    articleId: number = 0;
    description: string = '';
    observation: string | null = null;
    dateArticleTask: string | null = null;
    noticeDay: number = DaysNoticeEnums.sinAviso;
    frequency: number = FrequencyEnums.ninguna;
    state: boolean = false;
    createDate: string | null = null;
    userNameCreate: string | null = null;
    updateDate: string | null = null;
    userNameUpdate: string | null = null;
}
